import { render, staticRenderFns } from "./PostTypes.vue?vue&type=template&id=1cd82eb2&"
import script from "./PostTypes.vue?vue&type=script&lang=js&"
export * from "./PostTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports